import React from "react";
import { Button, Typography, Stack } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useHistory } from "react-router-dom";

export default function DashboardButton() {
  const history = useHistory();

  const goToDashboard = () => {
    history.push("/app/dashboard");
  };

  return (
    <Button
      variant="contained"
      sx={{
        borderRadius: "999px",
        backgroundColor: "white",
        color: "#004660",
        textTransform: "none",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
        paddingX: 3,
        paddingY: 1.2,
      }}
      onClick={goToDashboard}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <PersonOutlineIcon fontSize="small" />
        <Typography fontWeight="600">Minha área</Typography>
      </Stack>
    </Button>
  );
}
